// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CreditCard20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CreditCard20: FC<CreditCard20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="21"
        >
            <path d="M18 5.985v9c0 .403-.147.754-.44 1.052a1.433 1.433 0 0 1-1.06.448h-13a1.44 1.44 0 0 1-1.052-.448A1.44 1.44 0 0 1 2 14.985v-9c0-.403.15-.753.448-1.052A1.44 1.44 0 0 1 3.5 4.485h13c.413 0 .766.15 1.06.448.293.299.44.65.44 1.052Zm-14.5 1.5h13v-1.5h-13v1.5Zm0 3v4.5h13v-4.5h-13Z" />
        </svg>
    );
};

export default CreditCard20;
